export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/twoD.2f1f8dc.svg";